import * as ActionTypes from './ActionTypes';
import initialState from './InitialState';
import IFeatureState from '../../store/IFeatureState';
import { assign } from '../../shared/Assign';

export default function photographerAgreementReducer(
    state: any = initialState.photographerAgreement,
    action: { type: string; result: any }
): any {
    let newState: IFeatureState;

    switch (action.type) {
        case ActionTypes.LIST_AGREEMENT_PRODUCTS_SUCCESS:
            newState = assign({}, state);
            newState.list = action.result;
            return newState;
        default:
            return state;
    }
}
